"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.targetOptions = exports.relOptions = void 0;
var relOptions = ['noopener', 'noreferrer'];
exports.relOptions = relOptions;
var targetOptions = ['_self', '_blank', '_parent', '_top'];
exports.targetOptions = targetOptions;